import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = { class: "relative" };
var _hoisted_2 = ["value"];
var _hoisted_3 = {
    for: "email",
    class: "px-2"
};
var _hoisted_4 = /*#__PURE__*/ _createElementVNode("i", { class: "icon-close_circle text-24px text-grey-95" }, null, -1);
var _hoisted_5 = [
    _hoisted_4
];
var _hoisted_6 = {
    key: 1,
    class: "ml-6 mt-1 h-8 text-feed-red text-10px font-bold"
};
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'inputEmail',
    props: {
        value: { type: String, required: true },
        label: { type: String, required: false, default: 'メールアドレス' },
        requiredMessage: { type: String, required: false, default: 'メールアドレスは必須です' },
        initialMessage: { type: String, required: false, default: '' },
    },
    emits: [
        'updateValue',
        'checkInputValue',
    ],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        var errorMessage = ref('');
        var email = ref(null);
        var check = function (v) {
            var regex = /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
            return regex.test(v);
        };
        var updateValue = function (v) {
            emit('updateValue', { value: v, isValid: true });
        };
        var checkInputValue = function (v) {
            errorMessage.value = '';
            if (!v) {
                errorMessage.value = props.requiredMessage;
            }
            else if (!check(v)) {
                errorMessage.value = "\u6709\u52B9\u306A\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u5F62\u5F0F\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044";
            }
            emit('checkInputValue', { value: v, isValid: !errorMessage.value });
        };
        var clearValue = function () {
            if (email.value) {
                updateValue('');
            }
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("input", {
                    ref_key: "email",
                    ref: email,
                    type: "email",
                    name: "email",
                    id: "email",
                    class: _normalizeClass(["floating-label p-6 pr-12 w-full text-16px leading-none border border-grey-95 rounded", [!__props.value ? '' : 'value']]),
                    value: __props.value,
                    onInput: _cache[0] || (_cache[0] = function ($event) { return (updateValue($event.target.value)); }),
                    onBlur: _cache[1] || (_cache[1] = function ($event) { return (checkInputValue($event.target.value)); })
                }, null, 42, _hoisted_2),
                _createElementVNode("label", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(__props.label), 1)
                ]),
                (__props.value)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "absolute right-1 top-2 p-4",
                        onClick: clearValue
                    }, _hoisted_5))
                    : _createCommentVNode("", true),
                (errorMessage.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(errorMessage.value), 1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
